import { WsSelect, WsSelectObj, BriefcaseBusinessIcon } from 'wisestep-base';

import WsFilterProps from '../models/WsFilterProps';

import WsAccordion from './WsAccordion';
const options: WsSelectObj[] = [
  {
    label: 'Select',
    value: '',
  },
  {
    label: 'Temporary',
    value: 'Temporary',
  },
  {
    label: 'Permanent',
    value: 'Permanent',
  },
  {
    label: 'Contract',
    value: 'Contract',
  },
  {
    label: 'Freelance',
    value: 'Freelance',
  },
  {
    label: 'None',
    value: 'None',
  },
  {
    label: 'Internship',
    value: 'Internship  ',
  },
];

const JobTypeFilter = ({
  name,
  optionsList,
  title = 'Job Type',
  showAccordionIcon,
}: WsFilterProps) => (
  <WsAccordion title={title} {...(showAccordionIcon && { startIcon: <BriefcaseBusinessIcon /> })}>
    <WsSelect name={name} selectArray={optionsList ? optionsList : options} placeholder="Select" />
  </WsAccordion>
);
export default JobTypeFilter;
